<div class="w-100 h-100">
    <div class="row" style="padding-top: 25px;padding-bottom: 25px;">
        <div class="col-md-12">
            <div class="form-row justify-content-between align-items-baseline">
                <div class="col-auto">
                    <label class="header_text mb-3">
                        {{$t('shared.preApprovedTemplateDetails')}}
                    </label>
                </div>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-md-12">
            <div class="card card_layout">
                <div class="card-body card_body_layout">
                    <div class="row">

                        <div class="col-md-12">
                            <div class="row">
                                <div class="col-sm-4 mb-3">
                                    <label class="user_info_header mb-0">{{$t('shared.templateId')}}</label>
                                    <h4 class="user_info_txt">{{ model.templateCode }}</h4>
                                </div>
                                <div class="col-sm-4 mb-3">
                                    <label class="user_info_header mb-0">{{$t('shared.templateName')}}</label>
                                    <h4 class="user_info_txt">{{ model.name }}</h4>
                                </div>
                                <div class="col-sm-4 mb-3">
                                    <label class="user_info_header mb-0">{{$t('shared.classification')}}</label>
                                    <h4 class="user_info_txt">{{ classificationLabel(model.classification) }}</h4>
                                </div>
                                <div class="col-sm-4 mb-3">
                                    <label class="user_info_header mb-0">{{$t('shared.createdDate')}}</label>
                                    <h4 class="user_info_txt">{{ formatDate(model.createdDate) }}</h4>
                                </div>
                                <div class="col-sm-8 mb-3">
                                    <label class="user_info_header mb-0">{{$t('shared.templateDescription')}}</label>
                                    <h4 class="user_info_txt">{{ model.description || '-' }}</h4>
                                </div>

                                <div class="col-md-12 mt-4">
                                    <label class="user_info_header mb-2">{{$t('shared.templateContent')}}</label>
                                    <textarea rows="4"
                                              class="form-control"
                                              style="resize: none; background-color: #f8f9fa; color: #000; font-weight: 500;"
                                              v-model="substitutedText"
                                              readonly>
                                    </textarea>
                                </div>

                                <div class="col-md-12 mt-4" v-if="variablesMapping.length">

                                    <label class="user_info_header mb-3">
                                        {{ $t('shared.templateVariables') }}
                                    </label>

                                    <table class="table table-bordered text-center">
                                        <thead>
                                            <tr>
                                                <th style="width: 40%;">Variable</th>
                                                <th style ="width: 60%;">Value</th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            <tr v-for="(item,index) in variablesMapping"
                                                :key="index">

                                                <td>{{ item.key }}</td>
                                                <td>{{ item.value }}</td>

                                            </tr>
                                        </tbody>
                                    </table>

                                </div>
                            </div>
                        </div>

                        <div class="col-md-12 mt-5">
                            <div class="form-row justify-content-end align-items-center">
                                <div class="col-auto mx-3">
                                    <router-link to="/PreApprovedTemplates" tag="a" class="link_secondary">{{$t('shared.back')}}</router-link>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>